export default {
  metaTitleTemplate: {
    id: 'home_meta_title_template',
    defaultMessage: '%s | Back Market',
  },
  e2eTranslationCheck: {
    id: 'home-page-e2e-translation-check',
    defaultMessage: 'Home page e2e translations check default message',
  },
}
